import { BellIcon } from "./BellIcon";
import { ChatIcon } from "./ChatIcon";
import { CloseIcon } from "./CloseIcon";
import { ContactsIcon } from "./ContactsIcon";
import { DownloadIcon } from "./DownloadIcon";
import { EditIcon } from "./EditIcon";
import { FileAddIcon } from "./FileAddIcon";
import { FileIcon } from "./FileIcon";
import { FileUploadIcon } from "./FileUploadIcon";
import { FilterIcon } from "./FilterIcon";
import { FolderAddIcon } from "./FolderAddIcon";
import { GlobeIcon } from "./GlobeIcon";
import { InfoIcon } from "./InfoIcon";
import { KeyIcon } from "./KeyIcon";
import { LeftIcon } from "./LeftIcon";
import { LockIcon } from "./LockIcon";
import { LogIcon } from "./LogIcon";
import { MemberAddIcon } from "./MemberAddIcon";
import { MembersIcon } from "./MembersIcon";
import { NoteIcon } from "./NoteIcon";
import { OrgIcon } from "./OrgIcon";
import { PlusIcon } from "./PlusIcon";
import { RelocateIcon } from "./RelocateIcon";
import { RightIcon } from "./RightIcon";
import { RoleIcon } from "./RoleIcon";
import { RoomsAddIcon } from "./RoomsAddIcon";
import { RoomsIcon } from "./RoomsIcon";
import { SearchIcon } from "./SearchIcon";
import { SettingsIcon } from "./SettingsIcon";
import { ShareIcon } from "./ShareIcon";
import { ShieldIcon } from "./ShieldIcon";
import { TextEditIcon } from "./TextEditIcon";
import { TrashIcon } from "./TrashIcon";
import { VerifyIcon } from "./VerifyIcon";
import { VerticalIcon } from "./VerticalIcon";
import { VisibleIcon } from "./VisibleIcon";
import { WatermarkIcon } from "./WatermarkIcon";
import { AddChatIcon } from './AddChatIcon';
import { ChatSettingIcon } from './ChatSettingIcon';
import { PasswordIcon } from "./PasswordIcon";
import { DoubleLeftIcon } from "./DoubleLeft";
import { DoubleRightIcon } from "./DoubleRight";
import { TelegramIcon } from "./TelegramIcon";
import { MemberIcon } from "./MemberIcon";
import { FileDownloadIcon } from "./FileDownloadIcon";
import { VkIcon } from "./VkIcon";
import { YandexIcon } from "./YandexIcon";
import { CreditCardIcon } from "./CreditCardIcon";
import { FilePdfIcon } from "./FilePdfIcon";
import { FileZipIcon } from "./FileZipIcon";
import { EyeIcon } from "./EyeIcon";
import { FileEditIcon } from "./FileEditIcon";

const Assets = {
  OrgIcon,
  BellIcon,
  ChatIcon,
  ContactsIcon,
  RoomsIcon,
  RoomsAddIcon,
  CloseIcon,
  FilterIcon,
  ShieldIcon,
  FileIcon,
  FileEditIcon,
  MemberIcon,
  MembersIcon,
  SearchIcon,
  VerticalIcon,
  SettingsIcon,
  TrashIcon,
  EditIcon,
  EyeIcon,
  PlusIcon,
  FileUploadIcon,
  FolderAddIcon,
  KeyIcon,
  RightIcon,
  WatermarkIcon,
  MemberAddIcon,
  LogIcon,
  LockIcon,
  RoleIcon,
  RelocateIcon,
  ShareIcon,
  TextEditIcon,
  DownloadIcon,
  FileAddIcon,
  LeftIcon,
  VisibleIcon,
  VerifyIcon,
  InfoIcon,
  NoteIcon,
  GlobeIcon,
  AddChatIcon,
  ChatSettingIcon,
  PasswordIcon,
  DoubleLeftIcon,
  DoubleRightIcon,
  TelegramIcon,
  FileDownloadIcon,
  VkIcon,
  YandexIcon,
  CreditCardIcon,
  FilePdfIcon,
  FileZipIcon,
}

export default Assets;
